import { Link } from "react-router-dom";
import { relatedLink } from "@/mocks/manga";

const bg =
  "https://readdy.ai/api/search-image?query=Soft%20dreamy%20romance%20background%20with%20rose%20pink%20and%20warm%20gold%20gradient%2C%20floating%20cherry%20blossom%20petals%20and%20soft%20bokeh%2C%20gentle%20light%2C%20ethereal%20atmosphere%2C%20no%20text%2C%20smooth%20calming%20colors%2C%20high%20quality%20abstract%20art&width=1600&height=640&seq=cta-bg&orientation=landscape";

export default function CtaBand() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={bg} alt="" aria-hidden="true" className="h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/70 to-background-50/40"></div>
      </div>
      <div className="relative mx-auto flex max-w-7xl flex-col items-start gap-6 px-4 py-16 md:px-6 md:py-24">
        <h2 className="max-w-xl font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
          {relatedLink.title}
        </h2>
        <p className="max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">{relatedLink.desc}</p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/catalog"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-book-open-line text-base"></i>
            进入阅读目录
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-background-300 bg-background-50/70 px-7 py-3 text-sm font-semibold whitespace-nowrap text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            联系我们
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}